document.addEventListener('DOMContentLoaded', () => {
  const currentUrl = window.location.pathname;
  const newsletter = document.querySelector('.shopify-section-group-footer-group ');
  
  if (currentUrl === '/pages/contact' || currentUrl === '/pages/nosotros' ) {
    if (newsletter) {
      newsletter.style.display = 'none';
    }
  }
});
